import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError, EMPTY } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    public constructor(
        @Inject(DOCUMENT) private readonly doc: Document,
    ) {
        //
    }

    public intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        return next.handle(req).pipe(
            catchError((error: unknown) => {
                if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 419)) {
                    this.doc.location.replace('/login');
                    return EMPTY;
                }
                return throwError(() => error);
            }),
        );
    }
}
